module.exports = __webpack_public_path__ + "img/2x2.e61f20fb.png";